import React, { useContext } from "react";
import {
  BrowserRouter,
  Switch,
  Route
} from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Footer from "./components/Footer";
import { Context } from "./context/context";
import AdminSetup from "./pages/AdminSetup";
import Authorized from "./pages/Authorized";
import DaoDetails from "./pages/DaoDetails";
import Profile from "./pages/Profile";
import ProposalInfo from "./pages/ProposalInfo";
import LoadingBar from 'react-top-loading-bar'
import EvaluateProposal from "./pages/EvaluateProposal";
import Home from "./pages/Home";



function App() {

  let { progress, setProgress } = useContext(Context)

  return (
    <div className="App">
      <BrowserRouter basename="/dao" >
        <LoadingBar
          color='#01a94d'
          progress={progress}
          height={5}
          onLoaderFinished={() => setProgress(0)}
        />
        <ToastContainer pauseOnFocusLoss={false} />
          <Switch>
            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/dashboard">
              <DaoDetails />
            </Route>
            <Route exact path="/proposal-info/:id">
              <ProposalInfo />
            </Route>
            <Route exact path="/profile">
              <Profile />
            </Route>
            <Route exact path="/admin">
              <AdminSetup />
            </Route>
            <Route exact path="/authorized">
              <Authorized />
            </Route>
            <Route exact path="/evaluate-proposal">
              <EvaluateProposal />
            </Route>
          </Switch>
          
      </BrowserRouter>
    </div>
  );
}

export default App;
